import { markdown } from "markdown";
import { Row } from "./row";

export type CommentType = "entry" | "user" | "topic";

export interface CommentJSON {
  id: number;
  user_id: number;
  entry_id: number;
  created: Date;
  content: string;
  anonymous: boolean;
  likes: number;
  type: CommentType;
  hidden: boolean;
}

export class Comment extends Row<CommentJSON> implements CommentJSON {
  declare id: number;
  declare user_id: number;
  declare entry_id: number;
  declare created: Date;
  declare hidden: boolean;
  declare content: string;
  declare anonymous: boolean;
  declare likes: number;
  declare type: CommentType;

  constructor(props: CommentJSON) {
    super(props);

    this.created = new Date(this.created);
  }

  public get content_escaped(): string {
    return markdown.toHTML(
      this.content.replace(":thonk:", "![thonk](/img/thonk.png)") || "",
    );
  }

  public content_escaped_trunc(len = 100): string {
    let preMarkdown = this.content.slice(0, len) || "";
    if (this.content.length > len) {
      preMarkdown += "...";
    }

    let content = markdown.toHTML(preMarkdown);

    return content;
  }
}

export function IsComment(x: any): x is CommentJSON {
  return x.id && x.content && x.created && x.user_id && x.entry_id;
}
